import { QUERY_PARAMETERS, COOKIE_DATA, SCRIPT_LOADED_EVENT, INITIALIZED_EVENT } from './shared-constants.js';
import { EVENTS } from './web-events.js';

const executeAfterPricingContextEvent = (event, callback, continueListening) => {
  if (typeof callback !== "function") {
    return;
  }
  if (Object.values(EVENTS).indexOf(event) === -1) {
    console.warn(`Event '${event}' is NOT a valid pricing context event.`);
    return;
  }
  if (!windowAndDocumentExist()) {
    return;
  }
  window.document.addEventListener(event, function onEvent(e) {
    if (!continueListening) {
      window.document.removeEventListener(event, onEvent, false);
    }
    callback(e.detail);
  });
};
const getPcxtV3 = () => {
  if (!windowAndDocumentExist()) {
    return void 0;
  }
  return window.document.pcxtV3;
};
const windowAndDocumentExist = () => {
  return typeof window !== "undefined" && window.document;
};
const appendSubtenant = (queryString, subtenant) => {
  if (subtenant.length === 0) {
    console.error(`Invalid subtenant value ${subtenant.toString()}`);
    return queryString;
  }
  return queryString + `&subtenant=${subtenant}`;
};
const isSubtenantMandatory = (merchantId) => {
  const merchantsWithSubtenancy = ["VCS"];
  return merchantsWithSubtenancy.some((merchantWithSubtenancy) => merchantWithSubtenancy === merchantId.toUpperCase());
};
const registerCustomInitCallback = (configuration, callback) => {
  if (typeof callback !== "function") {
    return;
  }
  if (window.document.pcxtV3 && window.document.pcxtV3.isInitialized(configuration.merchantId, configuration.market, configuration.isDevelopmentMode)) {
    callback(window.document.pcxtV3.getPricingContext());
  } else {
    window.document.addEventListener(INITIALIZED_EVENT, function onInit(e) {
      window.document.removeEventListener(INITIALIZED_EVENT, onInit, false);
      callback(e.detail);
    });
  }
};
const callPCMInit = (configuration) => {
  const ignore = () => {
  };
  window.document.pcxtV3.init(configuration.merchantId, configuration.market, configuration.isDevelopmentMode).catch(ignore);
};
const initializePricingContext = (configuration, callback) => {
  if (!windowAndDocumentExist()) {
    return;
  }
  registerCustomInitCallback(configuration, callback);
  if (window.document.pcxtV3) {
    callPCMInit(configuration);
  } else {
    window.document.addEventListener(SCRIPT_LOADED_EVENT, function callback2() {
      window.document.removeEventListener(SCRIPT_LOADED_EVENT, callback2, false);
      callPCMInit(configuration);
    });
  }
};
var helpers = {
  executeAfterPricingContextEvent,
  getPcxtV3,
  appendSubtenant,
  isSubtenantMandatory,
  initializePricingContext,
  EVENTS,
  COOKIE_DATA,
  QUERY_PARAMETERS
};

export { COOKIE_DATA, EVENTS, QUERY_PARAMETERS, appendSubtenant, helpers as default, executeAfterPricingContextEvent, getPcxtV3, initializePricingContext, isSubtenantMandatory };
//# sourceMappingURL=pricing-context-module-helpers.js.map
